import { action, observable, runInAction } from "mobx";
import { ServiceBase } from "../ServiceBase";
import { IServiceFactoryExtended } from "../service-factory-extended.interface";
import { IPlayerBurnoutService } from "./player-burnout.service.interface";
import { CGPEventSubscription } from "../sdk/cgp-sdk.interface";
// import { IMessageDataJson } from "../../../common/interfaces/firebase-messages-handler";
import { OnGameOpenParams } from "../sdk/sdk-events";

export class PlayerBurnoutService extends ServiceBase implements IPlayerBurnoutService {
    private readonly _isRealMoneyPrize: boolean;

    @observable
    public renderAnimation = false;

    private _burnoutMessageEventSubscription: CGPEventSubscription | null = null;
    private _omgDisplayedEventSubscription: CGPEventSubscription | null = null;
    private _gameShowEventSubscription: CGPEventSubscription | null = null;
    private _gameCloseEventSubscription: CGPEventSubscription | null = null;
    private _currentlyDisplayedOmgs: unknown[] = [];

    constructor(serviceFactory: IServiceFactoryExtended) {
        super(serviceFactory);

        this.reaction(() => this.services.user.isAuthorized,
            this._onAuthStateChange,
            { fireImmediately: true }
        );

        this._isRealMoneyPrize = this.services.configuration.servicesConfigs.PlayerBurnout.isRealMoneyPrize;
    }

    private _onAuthStateChange = (isAuthorized) => {
        if (isAuthorized) {
            this._subscribe();
        } else {
            this._unsubscribe();
            // Actually I want to remove the floating button if any exists
            this.renderAnimation = false;
        }
    }

    private _subscribe() {
        this._burnoutMessageEventSubscription = this.services.sdk.events.onBurnoutMessageReceived(this._onBurnoutMessageReceivedEvent);
        this._gameShowEventSubscription = this.services.sdk.events.onGameOpen((params: OnGameOpenParams) => {
            this._currentlyDisplayedOmgs = [];
            if (params.isReal && !this._isRealMoneyPrize) {
                this._omgDisplayedEventSubscription = this.services.sdk.events.onOmgDisplayed(this._onOmgDisplayedEvent);
            }
        });
        this._gameCloseEventSubscription = this.services.sdk.events.onGameClose(() => {
            this._currentlyDisplayedOmgs = [];
            // Actually I want to remove the floating button if any exists
            runInAction(() => { this.renderAnimation = false; });
            if (this._omgDisplayedEventSubscription) {
                this._omgDisplayedEventSubscription.off();
            }
        });
    }

    private _unsubscribe() {
        this._currentlyDisplayedOmgs = [];
        if (this._burnoutMessageEventSubscription) {
            this._burnoutMessageEventSubscription.off();
        }
        if (this._omgDisplayedEventSubscription) {
            this._omgDisplayedEventSubscription.off();
        }
        if (this._gameShowEventSubscription) {
            this._gameShowEventSubscription.off();
        }
        if (this._gameCloseEventSubscription) {
            this._gameCloseEventSubscription.off();
        }
    }

    private _onOmgDisplayedEvent = (omgData: unknown) => {
        this._currentlyDisplayedOmgs.push(omgData);
    }

    @action
    private _onBurnoutMessageReceivedEvent = (/* dataJson: IMessageDataJson */) => {
        this.renderAnimation = true;
    }

    public showOmg = () => {
        this.services.sdk.bringOmgToFront();
        this._currentlyDisplayedOmgs = [];
    }

    public checkIfOmgDisplayed = () => {
        //or maybe just query DOM?
        return this._currentlyDisplayedOmgs.length > 0;
    }

    public getBurnoutAnimationZIndex() {
        return this.services.sdk.getBurnoutAnimationZIndex();
    }
}
